import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import AlertReducer from "./reducers/alert";
import UserReducer from "./reducers/user";
import UiReducer from "./reducers/ui";

const alertPersistConfig = {
  key: "alert",
  storage,
};

const userPersistConfig = {
  key: "user",
  storage,
};

const uiPersistConfig = {
  key: "ui",
  storage,
};

const persistedAlertReducer = persistReducer(alertPersistConfig, AlertReducer);
const persistedUserReducer = persistReducer(userPersistConfig, UserReducer);
const persistedUiReducer = persistReducer(uiPersistConfig, UiReducer);

const rootReducer = {
  alert: persistedAlertReducer,
  user: persistedUserReducer,
  ui: persistedUiReducer,
};

const store = configureStore({
  reducer: rootReducer,
});

const persistor = persistStore(store);

export { store, persistor };
